import * as React from 'react';

import IsolatedLayoutHeader from './IsolatedLayoutHeader';

interface IsolatedLayoutProps {
    LeftHeaderComponent?: React.ReactElement;
    RightHeaderComponent?: React.ReactElement;
    children?: React.ReactNode;
}

const IsolatedLayout: React.FC<IsolatedLayoutProps> = ({ children, LeftHeaderComponent, RightHeaderComponent }) => (
    <>
        <IsolatedLayoutHeader LeftComponent={LeftHeaderComponent} RightComponent={RightHeaderComponent} />
        {children}
    </>
);

export default IsolatedLayout;
